<h5>({{ this.events.length }}) Eventos</h5>
<div *ngFor="let item of this.events;"
     class="flex surface-card flex-column w-full border-1 surface-border p-2 gap-5 hover:surface-ground cursor-pointer border-round">
    <div class="flex justify-content-between align-items-center">
        <div class="flex flex-column">
            <p class="text-720 font-semibold mb-2 md:mb-0 text-blue-500">
                <i class="pi pi-tags text-blue-500"></i> {{ item.types }}
            </p>
            <span class="text-900 font-semibold">{{ item.title }} #{{ item.eventId }}</span>
        </div>
        <div>
            <p-tag [style]="tagBgStyle(item)"
                   [value]="item.status">
            </p-tag>
        </div>
    </div>
    <div style="word-break: break-word" class="text-700"
    >{{ item.description }}
    </div>
    <div class="flex align-items-center justify-content-between flex-column md:flex-row gap-4 md:gap-0">
        <div class="flex align-items-center"
             [style]="tagBgStyle(item)"
             [style.border-radius]="'2.5rem'">
                        <span class="text-white flex align-items-center justify-content-center border-circle mr-2"
                              [style]="tagColorStyle(item)"
                              style="min-width:2rem; min-height: 2rem">
                            <i class="pi pi-clock"></i>
                        </span>
            <span [style]="tagColorStyle(item)" [pTooltip]="'Fecha inicio programada'">
                            {{ item.startDate | date:"M/d/yy, h:mm a" }}
                        </span>
        </div>
    </div>
</div>